import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  title: 'ID Verification',
  statusLabel: 'Status',
  description:
    "Verifying your ID means you'll be able to make transfers from your Zeller Account, order and link cards for your Zeller Account and add or update your bank account.",
  verifyMyId: 'Verify My ID',
})
